// client/src/api/questService.js — R34b : quêtes quotidiennes + passe newbie
import api from './api';

export const getQuests = async () => {
  try {
    const r = await api.get('/quests');
    return r.data;
  } catch (e) {
    return { success: false, dailies: [], newbie: null };
  }
};

export const claimDaily = async (questId) => {
  const r = await api.post('/quests/daily/claim', { questId });
  return r.data;
};

export const rerollDaily = async (questId) => {
  const r = await api.post('/quests/daily/reroll', { questId });
  return r.data;
};

export const claimNewbie = async (day) => {
  const r = await api.post('/quests/newbie/claim', { day });
  return r.data;
};
